import { MutationTree } from 'vuex'
import { INotificationState } from '@/store/notification'
import { Types, Unread } from '@/store/notification/types'

const mutations: MutationTree<INotificationState> = {
  [Types.unread]: (state, action: Unread) => {
    state.unread = action.payload
  }
}

export default mutations
